import React from 'react';

import { PulseIconVariant } from 'src/components/icons/Pulse';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export type PlayIconVariant = Extract<
  PulseIconVariant,
  PulseIconVariant.Error | PulseIconVariant.WarnYellow | PulseIconVariant.WarnAmber
>;

interface PlayIconProps extends SimpleIconInterface {
  variant: PlayIconVariant;
}

export function PlayIcon({ className, height, variant, width }: PlayIconProps): JSX.Element {
  const fill =
    variant === PulseIconVariant.Error
      ? IconColors.Error
      : variant === PulseIconVariant.WarnAmber
        ? IconColors.WarnAmber
        : IconColors.WarnYellow;

  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <circle cx="12" cy="12" fill={fill} r="12" />
      <path d="M9.3335 16.6693V7.33594L16.6668 12.0026L9.3335 16.6693Z" fill="#FFFFFF" />
    </SimpleIcon>
  );
}
